import React from 'react'
import logo from "../../asstes/images/logo.png";
import facebook from "../../asstes/images/facebook.png";
import instagram from "../../asstes/images/instagram.png";
import linkidin from "../../asstes/images/linkidin.png"
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className='md:py-[70px] py-[20px]'>
        <div className='container'>
            <div className='flex items-start flex-col md:flex-row justify-between'>
                <div className='flex-[2] mb-3'>
                    <img src={logo} alt="" />
                </div>
                <div className='flex-[3] md:text-[20px] text-[14px] font-normal flex items-start lg:gap-[130px] md:gap-[70px] gap-[20px]'>
                    <div>
                        <ul className='footer_ul'>
                            <Link to={"/"}><li>Cómo funciona</li></Link>
                            <Link to={"/"}><li>Precios</li></Link>
                            <Link to={"/"}> <li>Dudas</li></Link>
                            <Link to={"/"}> <li>Carreras</li></Link>
                        </ul>
                    </div>
                    <div>
                        <ul className='footer_ul'>
                            <div className='flex items-start gap-5 py-[10px]'>
                                <Link to={"/"}><span>Redes sociales</span></Link>
                                <div className='md:flex items-center gap-4 hidden'>
                                    <a href="#"><img src={instagram} alt="" /></a>
                                    <a href="#"><img src={linkidin} alt="" /></a>
                                    <a href="#"> <img src={facebook} alt="" /></a>
                                </div>
                            </div>
                            <Link to={"/"}> <li>Aviso de privacidad</li></Link>
                            <Link to={"/"}> <li>Terminos y condiciones</li></Link>
                            <Link to={"/"}>  <li>Ciberconta ® 2022</li></Link>
                            
                            
                           
                        </ul>
                    </div>
                </div>
                <div className='md:hidden items-center gap-4 flex mt-4'>
                                    <a href="#"><img src={instagram} alt="" /></a>
                                    <a href="#"><img src={linkidin} alt="" /></a>
                                    <a href="#"> <img src={facebook} alt="" /></a>
                                </div>
            </div>
        </div>
    </div>
  )
}

export default Footer